/**
 * Shared floating-label helpers for FormGroupField and SelectField.
 */

/**
 * Returns whether the field has a value that should trigger the "floated" label state.
 * @param {object} field - Form field with .value
 * @param {{ excludeTypes?: string[] }} [options] - excludeTypes: e.g. ['checkbox', 'radio'] for inputs
 * @returns {boolean}
 */
export function hasFloatingValue(field, options = {}) {
  const { excludeTypes = [] } = options;
  const type = field.type;
  if (type && excludeTypes.includes(type)) return false;
  const v = field.value;
  if (v === undefined || v === null) return false;
  if (typeof v === 'number' && !Number.isNaN(v)) return true;
  return String(v).trim() !== '';
}
